import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
const included = [{
  label: '10 Volumi Completi',
  value: '87 €'
}, {
  label: '2 PDF di Attività Extra',
  value: '10 €'
}, {
  label: '5 Bonus Esclusivi',
  value: '95 €'
}];
export function PricingSection() {
  return <section id="prezzo" className="scroll-mt-24 bg-brand-alt px-4 py-20 md:py-28" data-id="element-128" data-mp="1ja9x95bb50hh">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-129" data-mp="1na0tvpnimatx">
        <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-green" data-id="element-130" data-mp="1s9403df8en3h">OFFERTA A TEMPO LIMITATO</p>
        <h2 className="mb-12 text-3xl font-black text-brand-deep md:text-4xl" data-id="element-131" data-mp="1x8gmxy63ru62">🏆 Offerta di Lancio</h2>
        <div className="relative mx-auto max-w-xl overflow-hidden rounded-[2rem] border-2 border-brand-green bg-brand-alt shadow-xl" data-id="element-132" data-mp="2282w9wit8q9l">
          <div className="bg-brand-deep px-6 py-4 text-[11px] font-extrabold tracking-[0.14em] text-white" data-id="element-133" data-mp="2wjnpj1f5k0g">
            BIOLOGIA PRONTA — PACCHETTO COMPLETO
          </div>
          <div className="p-8 md:p-12" data-id="element-134" data-mp="1mhpz060ob8eq">
            <ul className="space-y-4 text-left" data-id="element-135" data-mp="1mihn6vrxy3uz">
              {included.map(({
              label,
              value
            }) => <li key={label} className="flex items-center justify-between gap-3 border-b border-brand-dark pb-4 text-sm" data-id="element-136" data-mp="1ho508br9aaeh">
                  <span className="flex items-center gap-3" data-id="element-137" data-mp="17tlgp35j8ywh">
                    <CheckCircle2Icon className="h-5 w-5 shrink-0 text-brand-green" aria-hidden="true" data-id="element-138" data-mp="25fsik5agcd55" />
                    <span className="font-medium" data-id="element-139" data-mp="20hhde7v3qqt9">{label}</span>
                  </span>
                  <span className="shrink-0 font-bold text-brand-deep" data-id="element-140" data-mp="1vgl75nna2sko">{value}</span>
                </li>)}
              <li className="flex items-center justify-between gap-3 pt-1 text-sm font-bold" data-id="element-141" data-mp="1rezotmrz5m33">
                <span data-id="element-142" data-mp="k2z9tf79lko2">VALORE TOTALE:</span>
                <span className="text-brand-green line-through" data-id="element-143" data-mp="jzuze037hsoy">192 €</span>
              </li>
            </ul>
            <div className="my-8 border-y border-brand-dark py-7" data-id="element-144" data-mp="hhrs2va92tm3">
              <p className="text-xs font-extrabold tracking-[0.16em] text-brand-green" data-id="element-145" data-mp="hijbz8uhj2wj">SOLO OGGI</p>
              <p className="mt-2 font-serif text-6xl font-black tracking-tight text-brand-deep md:text-7xl" data-id="element-146" data-mp="mg31x60jp44b">
                19 <span className="text-2xl" data-id="element-147" data-mp="7ly84qu7bxua">€</span>
              </p>
              <p className="mt-3 text-xs font-semibold text-brand-gray" data-id="element-148" data-mp="ch3shl7yh4g9">Pagamento unico · Accesso immediato</p>
            </div>
            <CTAButton href="https://biologia-pronta.impultienda.ar/checkout" className="w-full py-5 text-lg" data-id="element-149" data-mp="3uul8f3au8blt">
              OTTIENI IL PACCHETTO BIOLOGIA PRONTA
            </CTAButton>
            <p className="mt-6 text-xs font-semibold text-brand-gray" data-id="element-150" data-mp="3l0bc5airyt5t">Accesso immediato dopo l’acquisto</p>
          </div>
        </div>
      </Reveal>
    </section>;
}